import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Select, MenuItem } from '@material-ui/core';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    marginRight: theme.spacing(1),
   
    fontWeight:"bold",
    fontSize: "14px"
  },
  option: {
    fontSize: "12px",
    width: "100px",

    "& .MuiSelect-outlined": {
      paddingTop: "8px",
      paddingBottom: "8px",
    },

    [theme.breakpoints.up("md")]: {
      "& .MuiSelect-outlined": {
        paddingTop: "18.5px",
        paddingBottom: "18.5px",
      },
    },
  },
}));

const TitleWithDropdown = ({ title, options, selectedOption, onOptionChange }) => {
  const classes = useStyles();
  const [visibility,setVisibility] = useState(false)
  const curremms=useSelector((state)=>state.curremms)
  
  
  const defaultOption = options && options.length > 0 ? options[0] : null;

  // A picker with nothing to pick is noise. Where this component is given an
  // options list (the "EMMS Service" selectors) and the tenant has a single
  // service, the whole row goes -- label included, since the label only exists
  // to name the control. Callers that pass no options at all (LicenseDashboard)
  // are using this purely as a section heading, so they are left alone.
  if (options && options.length < 2) {
    return null;
  }

  

  return (
    <>
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
       
      {options && options.length > 0 && (
        <Select   className={classes.option}
         variant='outlined'
         defaultValue="Select"
         value={selectedOption||defaultOption.value}  onChange={onOptionChange}>
        {options.map((option) => (
         <MenuItem key={option.value} value={option.value}>
            {option.label}
         </MenuItem>
       ))}
     </Select>
)}
      
      
      
    </div>
      </>
  );
};

export default TitleWithDropdown;
